var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-timeline',{attrs:{"dense":"","align-top":""}},[_vm._l((_vm.renderedFamilies),function(f,i){return _c('v-timeline-item',{key:i,attrs:{"color":f.isValidationSuccess
        ? 'success'
        : _vm.currentPos === i
        ? 'primary'
        : 'grey',"icon":f.isValidationSuccess
        ? _vm.currentPos === i
          ? 'mdi-check'
          : 'mdi-checkbox-marked-circle'
        : '',"small":""}},[_c('a',{class:_vm.currentPos === i ? 'primary--text font-weight-bold' : '',attrs:{"id":_vm.currentPos === i ? 'current-fam' : ''},on:{"click":function($event){return _vm.goToFamily(i)}}},[_vm._v(" "+_vm._s(f.label)+" ")])])}),_c('v-timeline-item',{key:_vm.renderedFamilies.length,attrs:{"color":_vm.isAllValidationSuccess
        ? 'success'
        : _vm.isCurrentPosReview
        ? 'primary'
        : 'grey',"icon":_vm.isAllValidationSuccess
        ? _vm.isCurrentPosReview
          ? 'mdi-check'
          : 'mdi-checkbox-marked-circle'
        : '',"small":""}},[_c('a',{class:_vm.isCurrentPosReview ? 'primary--text font-weight-bold' : '',attrs:{"id":_vm.isCurrentPosReview ? 'current-fam' : ''},on:{"click":function($event){return _vm.goToReview()}}},[_vm._v(" Review Questions ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }